<ul>

  <ng-container *ngIf="data.visibleMap.trackSpoPayment">
    <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('trackSpoPayment') }"></ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('obicSummary') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('ocSummary') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('taxHint') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('deliveryConditions') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('transportation') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('weightSection') }"></ng-container>
  <!-- <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('invoiceAddress') }"></ng-container> -->
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('termsOfPayment') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('paymentPlan') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('packingConditions') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('goodsReceived') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('associatedPfspoList') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('associatedOCList') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('generalText') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('contractCondition') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('commercialTerms') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('warranty') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('transferOfOwnership') }"></ng-container>
  <li [ngStyle]="{ 'padding-left': print ? '0' : '3rem', 'page-break-inside': 'avoid' }" *ngIf="showEnclosures()">
    <label>Enclosed documents</label>
    <ul class="enclosures" style="padding: 1em 2em 2em 2em !important">
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('documents') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('testCertificates') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('tcFromPfspo') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('technicalDatasheetPdf') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('finishedProductPdf') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('changelogFiles') }"></ng-container>
      <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('packingImages') }"></ng-container>
    </ul>
  </li>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('changelog') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('relatedDocuments') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('accountManager') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('invoiceRemark') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('issuedBy') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('bankAddress') }"></ng-container>
  <ng-container *ngIf="compilation.type != typeData.get('TOF').id">
    <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('barcodes') }"></ng-container>
    <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('qrcode') }"></ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('changelogLite') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('sendToSection') }"></ng-container>

  <div *ngIf="print && data.visibleMap.fiscalYear && compilation.visibleFields.includes('fiscalYear') && compilation.fiscalYear" style="margin-top:1rem">
    Expected financial year: {{getFiscalYear()}}
  </div>

  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('issuerFooter') }"></ng-container>
  <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('coverSheet') }"></ng-container>
  <ng-container *ngIf="compilation.type === typeData.get('DN').id">
    <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('dnBoxes') }"></ng-container>
  </ng-container>
</ul>


<ng-template #subComponent let-section>

  <li *ngIf="!doHide(section) && section && !print && isDocSection(section) && !section.pdfOnly">
    <table class="maintable">
      <tr>
        <td>
          <input *ngIf="!section.disabled && !section.noPdf" type="checkbox" [ngModel]="section.checked"
            (change)="toggleItem(section)" />
            <!-- [attr.disabled]="locked ? true : null" /> -->
        </td>
        <td>
          <label *ngIf="section.label">{{getSectionLabel(section?.label)}}</label>
          <ng-container *ngTemplateOutlet="templates[(section.template ? section.template : section.name)]; context: { $implicit: section }"></ng-container>
        </td>
      </tr>
    </table>
  </li>

  <li
    *ngIf="section.pageBreak && !doHide(section) && (isPrint(section) || (print && section.pdfOnly))"
    class="print-item-non-breakable nebular-4-preview-font-size-fix"
    style="page-break-before: always"
  >
      <label *ngIf="section.label">{{getSectionLabel(section?.label)}}</label>
      <ng-container *ngTemplateOutlet="templates[(section.template ? section.template : section.name)]; context: { $implicit: section }"></ng-container>
  </li>
  <li 
    *ngIf="!section.pageBreak && !doHide(section) && (isPrint(section) || (print && section.pdfOnly))"
    class="print-item-non-breakable nebular-4-preview-font-size-fix"
  >
      <label *ngIf="section.label">{{getSectionLabel(section?.label)}}</label>
      <ng-container *ngTemplateOutlet="templates[(section.template ? section.template : section.name)]; context: { $implicit: section }"></ng-container>
  </li>

</ng-template>

<!-- .................................................................. common textfield ..................................................................... -->

<ng-template [dynamic]="'text'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <div class="border-box">
      <ngx-form-text [multiline]="1" [(value)]="compilation[section.name]" [disabled]="isDisabled(section)"></ngx-form-text>
    </div>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <div class="border-box" [innerHTML]="sanitize(compilation[section.name])"></div>
    <!-- <div>{{compilation[section.name]}}</div> -->
  </ng-container>

</ng-template>


<!-- ================================================================================================================================================ -->

<!-- .................................................................. Track SPO payment .................................................................. -->

<ng-template [dynamic]="'trackSpoPayment'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <table class="nrk-table w-100">
      <tr>
        <th><button *ngIf="!locked" class="nrk-doc-button" (click)="addSpoPaymentItem()">+</button></th>
        <th>SPIN #</th><th>SPIN Date</th><th>SPIN Value</th><th>CURR</th><th>Payment Date</th><th>Fiscal Year</th><th>SPIN Upload</th><th>TR Upload</th>
      </tr>
      <ng-container *ngIf="compilation.spoPayment?.length">
        <tr *ngFor="let spin of compilation.spoPayment; index as idx">
          <td><button *ngIf="!locked" class="nrk-doc-button" (click)="removeSpoPayment(idx)">-</button></td>
          <td><ngx-doc-form-texfield [styles]="{'width':'100%'}" [(value)]="spin.spInvoice" [disabled]="locked"></ngx-doc-form-texfield></td>
          <td><ngx-doc-form-date [styles]="{'width':'100%'}" [(value)]="$any(spin).spInvoiceDate" [disabled]="locked"></ngx-doc-form-date></td>
          <td><ngx-doc-form-texfield [styles]="{'text-align':'right','width':'100%'}" [(value)]="spin.spInvoiceValue" mode="currency" [currency]="spin.currency || compilation.currency" [disabled]="locked"></ngx-doc-form-texfield></td>
          <!-- <td><ngx-doc-form-dropdown [styles]="{'text-align':'center'}" [value]="spin.currency || compilation.currency" (valueChange)="spin.currency = $event" [options]="Currency.getOptions()" [disabled]="locked"></ngx-doc-form-dropdown></td> -->
          <td><ngx-doc-form-dropdown [styles]="{'text-align':'center'}" [value]="spin.currency || compilation.currency" (valueChange)="spin.currency = $event" [options]="currencyOptions" [disabled]="locked"></ngx-doc-form-dropdown></td>
          <td><ngx-doc-form-date [styles]="{'width':'100%'}" [(value)]="$any(spin).paymentDate" [disabled]="locked"></ngx-doc-form-date></td>
          <td><ngx-doc-form-dropdown [(value)]="spin.fiscalYear" [options]="fiscalYearOptions" [disabled]="locked"></ngx-doc-form-dropdown></td>
          <td class="text-center"><i style="cursor:pointer" class="ionicon ion-upload h5" (click)="spoInWin.show()" title="Upload SPIN Document"></i>
            {{spin.spoInvoiceUpload?.url ? '✓' : ''}}
            <nrk-window #spoInWin>
              <nrk-header>Upload SPIN Document</nrk-header>
              <nrk-content>
                <ngx-form-upload [fullwidth]="true" [(file)]="spin.spoInvoiceUpload" (completed)="saveSpoPaymentUpload(spin, $event, idx, 1); spoInWin.close();" url="/api/v1/upload"></ngx-form-upload>
              </nrk-content>
            </nrk-window>
          </td>
          <td class="text-center" style="border-right:1px solid lightgray"><i style="cursor:pointer" class="ionicon ion-upload h5" (click)="spoTrWin.show()" title="Upload Transaction Receipt"></i>
            {{spin.transactionReceipt?.url ? '✓' : ''}}
            <nrk-window #spoTrWin>
              <nrk-header>Upload Transaction Receipt</nrk-header>
              <nrk-content>
                <ngx-form-upload [fullwidth]="true" [(file)]="spin.transactionReceipt" (completed)="saveSpoPaymentUpload(spin, $event, idx, 2); spoTrWin.close()" url="/api/v1/upload"></ngx-form-upload>
              </nrk-content>
            </nrk-window>
          </td>
        </tr>
      </ng-container>
      <tr>
        <td colspan="3" style="text-align: right">Subtotal Payments:</td>
        <td style="text-align:right;padding-right:2rem">{{getSpoPaymentTotal() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
        <td [attr.colspan]="locked ? 5 : 8"></td>
      </tr>
      <tr>
        <td colspan="3" style="text-align: right">Remaining Payments:</td>
        <td style="text-align:right;padding-right:2rem">{{getSpoPaymentDiff()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
        <td [attr.colspan]="locked ? 5 : 8"></td>
      </tr>
    </table>

    <!-- <ngx-profit-margin [compilation]="this.compilation" [type]="profitMarginType.cs"></ngx-profit-margin> -->
    <button *ngIf="['CS'].includes(typeData.get(compilation.type).code)" class="nrk-button" (click)="documentComponent.profitCalc.show()">CS Profit Margin</button>
   
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <table class="nrk-table">
      <tr>
        <th style="text-align:left;padding-left:10pt">SPIN #</th>
        <th style="text-align:center">SPIN Date</th>
        <th style="text-align:right">SPIN Value</th>
        <th style="text-align:center">Payment Date</th>
        <th style="text-align:center">SPIN Upload</th>
        <th style="text-align:center">TR Upload</th>
      </tr>
      <ng-container *ngIf="compilation.spoPayment?.length">
        <tr *ngFor="let spin of compilation.spoPayment; index as idx">
          <td style="text-align:left;padding-left:10pt">{{spin.spInvoice}}</td>
          <td style="text-align:center">{{spin.spInvoiceDate | date : 'yyyy-MM-dd'}}</td>
          <td style="text-align:right">{{spin.spInvoiceValue | currency : (spin?.currency || compilation.currency) : 'symbol' : '1.2-2' : 'de'}}</td>
          <td style="text-align:center">{{spin.paymentDate | date : 'yyyy-MM-dd'}}</td>
          <td style="text-align:center">{{spin.spoInvoiceUpload?.url ? '✓' : '-'}}</td>
          <td style="text-align:center">{{spin.transactionReceipt?.url ? '✓' : '-'}}</td>
        </tr>
      </ng-container>
      <tr>
        <td colspan="2" style="text-align: right">Subtotal Payments:</td>
        <td style="text-align: right">{{getSpoPaymentTotal() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">Remaining Payments:</td>
        <td style="text-align: right">{{getSpoPaymentDiff()  | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
        <td colspan="3"></td>
      </tr>
    </table>

  </ng-container>

</ng-template>

<!-- .................................................................. taxHint ..................................................................... -->

<ng-template [dynamic]="'taxHint'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <!-- <ngx-doc-store-dropdown [(value)]="compilation.taxHint" placeholder="" store="taxHintStore"
      placeholder="Select tax hint" [disabled]="isDisabled(section)"></ngx-doc-store-dropdown> -->
    <ngx-doc-form-filter-select [(value)]="compilation.taxHint" [options]="taxHintOptions" 
      placeholder="Select tax hint" [disabled]="isDisabled(section)"></ngx-doc-form-filter-select>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <!-- <div [innerHTML]="getSectionValue(true)"></div> -->
    <div class="border-box">{{compilation[section.name]}}</div>
  </ng-container>

</ng-template>

<!-- .................................................................. deliveryConditions ..................................................................... -->

<ng-template [dynamic]="'deliveryConditions'" let-section>

  <ng-container *ngIf="isScreen(section) && compilation.deliveryConditions">
    <table class="nrk-table w-100">
      <thead><tr>
      <th>Incoterms 2020 ICC</th>
      <th>ZIP & Place</th>
      <th>Country</th>
    </tr></thead><tbody>
      <tr>
      <td><ngx-doc-form-dropdown class="fullwidth" [disabled]="isDisabled(section)" [options]="incotermsOptions"
        [(value)]="compilation.deliveryConditions.incoterms"></ngx-doc-form-dropdown></td>
      <td><ngx-doc-form-texfield class="fullwidth" [placeholder]="section.label"
        [(value)]="compilation.deliveryConditions.place" [disabled]="isDisabled(section)"></ngx-doc-form-texfield></td>
      <td><ngx-doc-form-filter-select class="fullwidth" [options]="countryCodeOptions"
        [(value)]="compilation.deliveryConditions.country" [disabled]="isDisabled(section)"></ngx-doc-form-filter-select></td>
    </tr></tbody></table>        
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <table class="nrk-table w-100"><tr>
      <th style="text-align:left;padding-left:10pt">Incoterms 2020 ICC</th>
      <th style="text-align:left">ZIP & Place</th>
      <th style="text-align:left">Country</th>
    </tr><tr>
      <td style="padding-left:10pt"><div>{{compilation.deliveryConditions.incoterms}}</div></td>
      <td><div>{{compilation.deliveryConditions.place}}</div></td>
      <td><div>{{compilation.deliveryConditions.country}}</div></td>
    </tr></table> 
  </ng-container>

</ng-template>

<!-- .................................................................. transportation ..................................................................... -->

<!-- <ul>
  <li *ngIf="!selected.invoiceType || selected.invoiceType != 'service'">
    <label>Transportation</label>
    <div>Carrier / Method</div>
    <ngx-doc-form-filter-select class="fullwidth" [value]="tree?.linkedCS?.meansOfTransport || selected.meansOfTransport" placeholder="Select transportation"
      [options]="meansOfTransportOptions" (valueChange)="onMeansOfTransportChanged($event)" [disabled]="locked || selected.tmp?.relatedCombinedShipment">
    </ngx-doc-form-filter-select>
    <div *ngIf="!(locked || tree.linkedCS)" style="display:flex;flex-direction:row;margin-top:3px;width:100%;">
      <ngx-doc-form-texfield style="width:100%;" class="fullwidth" [(value)]="selected.meansOfTransport"></ngx-doc-form-texfield>
      &nbsp;<button class="nrk-doc-button" (click)="addMeansOfTransport()" title="Add transportation to list">+</button>
      &nbsp;<button class="nrk-doc-button" (click)="removeMeansOfTransport()" title="Remove transportation from list">-</button>
    </div>
  </li>
</ul> -->


<ng-template [dynamic]="'transportation'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <table class="terms-of-payment" style="padding:1rem;table-layout: fixed;">
      <tr><td>
        <div>Carrier / Method</div>
        <ngx-doc-form-filter-select class="fullwidth" [value]="tree?.linkedCS?.meansOfTransport || compilation.meansOfTransport" placeholder="Select transportation"
          [options]="meansOfTransportOptions" (valueChange)="onMeansOfTransportChanged($event)" [disabled]="locked || compilation.tmp?.relatedCombinedShipment">
        </ngx-doc-form-filter-select>
        <div *ngIf="!(locked || tree.linkedCS)" style="display:flex;flex-direction:row;margin-top:3px;width:100%;">
          <ngx-doc-form-texfield style="width:100%;" class="fullwidth" [(value)]="compilation.meansOfTransport"></ngx-doc-form-texfield>
          &nbsp;<button class="nrk-doc-button" (click)="addMeansOfTransport()" title="Add transportation to list">+</button>
          &nbsp;<button class="nrk-doc-button" (click)="removeMeansOfTransport()" title="Remove transportation from list">-</button>
        </div>
      </td><td>
        <div>Tracking Code</div>
        <ngx-form-text [multiline]="1" [(value)]="compilation.trackingCode" [disabled]="isDisabled(section)"></ngx-form-text>
      </td></tr>
    </table>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <!-- <div class="terms-of-payment" style="padding:1rem" *ngIf="((tree?.linkedCSs && tree?.linkedCSs[0]?.meansOfTransport) || compilation.meansOfTransport) && (!compilation.invoiceType || compilation.invoiceType != 'service')">
      <div>
        <div>Carrier / Method:</div>
        {{tree?.linkedCS?.meansOfTransport || compilation.meansOfTransport}}
      </div>
    </div>
    <div class="textbox" *ngIf="compilation.trackingCode">
      <div>Tracking Code:</div>
      {{compilation.trackingCode}}
    </div> -->

    <table class="nrk-table w-100">
      <tr>
        <th style="text-align:left;padding-left:10pt">Carrier / Method</th>
        <th  *ngIf="compilation.trackingCode">Tracking Code</th>
      </tr><tr>
        <td style="padding-left:10pt">{{tree?.linkedCS?.meansOfTransport || compilation.meansOfTransport}}</td>
        <td *ngIf="compilation.trackingCode">{{compilation.trackingCode}}</td>
      </tr>
    </table> 

  </ng-container>

</ng-template>

<!-- .................................................................. weight ..................................................................... -->

<ng-template [dynamic]="'weightSection'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <table class="terms-of-payment">
      <tr>
        <td style="padding-left:1rem">Total Net Weight: {{totalNetWeight | ngxRound}} kg</td>
        <td>Total Gross Weight: {{totalGrossWeight | ngxRound}} kg</td>
      </tr>  
    </table>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <table class="terms-of-payment">
      <tr>
        <td style="padding-left:1rem">Total Net Weight: {{totalNetWeight | ngxRound}} kg</td>
        <td>Total Gross Weight: {{totalGrossWeight | ngxRound}} kg</td>
      </tr>  
    </table>
  </ng-container>

</ng-template>

<!-- .................................................................. invoiceAddress ..................................................................... -->

<!-- <ng-template [dynamic]="'invoiceAddress'" let-section>

  <div>{{invoiceAddress}}</div>
  
</ng-template> -->

<!-- .................................................................. termsOfPayment ..................................................................... -->

<ng-template [dynamic]="'termsOfPayment'" let-section>

  <ng-container *ngIf="isScreen(section) && compilation.paymentPlan">
    <table class="terms-of-payment">
      <tr>
        <td style="width:4em;text-align:center;padding-left:1em">100%</td>
        <td *ngIf="compilation.paymentPlan.termsOfPayment !== 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY'">
          <!-- <ngx-doc-store-dropdown [(value)]="compilation.paymentPlan.text" store="paymentTextStore" placeholder="Select payment text" [disabled]="isDisabled(section)"></ngx-doc-store-dropdown> -->
          <ngx-doc-form-filter-select [(value)]="compilation.paymentPlan.text" [options]="data.paymentTextOptions" [disabled]="isDisabled(section)"></ngx-doc-form-filter-select>
          <!-- <ngx-form-text [multiline]="1" [(value)]="compilation.paymentPlan.text" [disabled]="isDisabled(section)"></ngx-form-text> -->
        </td>
        <td>
          <!-- <ngx-doc-store-dropdown [(value)]="compilation.paymentPlan.termsOfPayment" store="termsOfPaymentStore" placeholder="Select terms of payment" [disabled]="isDisabled(section)"></ngx-doc-store-dropdown> -->
          <ngx-doc-form-filter-select [(value)]="compilation.paymentPlan.termsOfPayment" [options]="data.termsOfPaymentOptions" [disabled]="isDisabled(section)"></ngx-doc-form-filter-select>
          <!-- <ngx-form-text [multiline]="1" [(value)]="compilation.paymentPlan.termsOfPayment" [disabled]="isDisabled(section)"></ngx-form-text> -->
        </td>
      </tr>  
    </table>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <table class="terms-of-payment" style="border: 1px solid lightgray">
      <tr>
        <td style="width:10%;text-align:center;padding-left:1em">100%</td>
        <td style="width:45%" [innerHTML]="sanitize(compilation.paymentPlan.text)"></td>
        <td style="width:45%;padding-left:1em" [innerHTML]="sanitize(compilation.paymentPlan.termsOfPayment)"></td>
      </tr>  
    </table>
  </ng-container>

</ng-template>

<!-- .................................................................. paymentPlan ..................................................................... -->

<ng-template [dynamic]="'paymentPlan'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-payment-plan [compilation]="this.compilation" [disabled]="isDisabled(section)"></ngx-payment-plan>

    <!-- <button *ngIf="['OC'].includes(typeData.get(compilation.type).code) " class="nrk-button" style="margin-top:0.5rem" (click)="profitOCSPO.show()">OC to SPO Profit Margin</button> -->
    <button *ngIf="['OC'].includes(typeData.get(compilation.type).code) " class="nrk-button" style="margin-top:0.5rem" (click)="documentComponent.profitCalcOCSPO.show()">OC to SPO Profit Margin</button>

  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-payment-plan [compilation]="this.compilation" [print]="true"></ngx-payment-plan>
  </ng-container>

</ng-template>

<!-- .................................................................. packingConditions ..................................................................... -->

<ng-template [dynamic]="'packingConditions'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <!-- <ngx-packing-conditions [compilation]="this.compilation" [disabled]="isDisabled(section)" [legacy]="true"></ngx-packing-conditions> -->
    <p><ngx-doc-form-checkbox [(value)]="compilation.useOldPackingConditions" label="use legacy packing details"></ngx-doc-form-checkbox></p>
    <ngx-packing-conditions [compilation]="this.compilation" [disabled]="isDisabled(section) || !compilation.useOldPackingConditions" [useOldPacking]="compilation.useOldPackingConditions" [legacy]="true"></ngx-packing-conditions>
    <ngx-packing-conditions [compilation]="this.compilation" [disabled]="isDisabled(section) || compilation.useOldPackingConditions"></ngx-packing-conditions>
    <ng-container *ngIf="config.checkVisible('labelButtons', compilation.type)">
      <button *ngIf="showUpdatePackingConditions()" class="nrk-button mb-2" (click)="updatePackingConditions()">Update from PL</button>
      <ngx-pallet-label [compilation]="compilation" [grossWeight]="0" [warehousingPopup]="single !== null"></ngx-pallet-label>
      <ngx-box-label [compilation]="compilation" [windowed]="true"></ngx-box-label>
    </ng-container>
    <button class="nrk-button mt-2" (click)="downloadSimpleBoxTableXLS()">Simple Box Table XLS</button>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-packing-conditions *ngIf="compilation.useOldPackingConditions" [compilation]="this.compilation" [print]="true" [grossWeight]="grossWeight" [legacy]="true" [disabled]="disabled"></ngx-packing-conditions>
    <ngx-packing-conditions *ngIf="!compilation.useOldPackingConditions" [compilation]="this.compilation" [print]="true" [grossWeight]="grossWeight" [warehousing]="single === 'packingConditions'" [disabled]="disabled"></ngx-packing-conditions>
  </ng-container>

</ng-template>

<!-- .................................................................. goodsReceived ..................................................................... -->

<ng-template [dynamic]="'goodsReceived'" let-section>

  <div class="goods-received"></div>
  <!-- <div class="goods-received-text">Date - Time - Name - Signature - Remark</div> -->
  <div class="goods-received-text">
    <table style="width:100%"><td>Date</td><td>-</td><td>Time</td><td>-</td><td>Name</td><td>-</td><td>Signature</td><td>-</td><td>Remark</td></table>
  </div>

</ng-template>

<!-- .................................................................. obicSummary ..................................................................... -->

<ng-template [dynamic]="'obicSummary'" let-section>

  <label>OBIC summary {{compilation.lineItems[0]?.tbCode || ''}}</label>
  <table class="nrk-table w-100">
    <tr>
      <th style="text-align:left;padding-left:10pt">SPO #</th>
      <th style="text-align:left">OBIC #</th>
      <th style="text-align:center" title="partial deliveries">PD</th>
      <th style="text-align:center">EXW date</th>
      <th style="text-align:center">ETA AT date</th>
      <th style="text-align:center">PFSPO status</th>
      <th style="text-align:center">Transport status</th>
      <th style="text-align:right">Q/unit</th>
      <th style="text-align:right;padding-right:10px">Q/pc.</th>
    </tr>
    <!-- <tr *ngFor="let doc of getAssociatedSpos(); index as idx"> -->
    <tr *ngFor="let doc of getAssociatedSpos(); index as idx">
      <td style="text-align:left;padding-left:10pt">{{ doc.doc | documentNumber : null : null : false }}</td>
      <td style="text-align:left">{{doc.doc?.lineItems?.[0]?.tbCode || ''}}</td>
      <td style="text-align:center">{{idx+1}}/{{getAssociatedSpos().length}}</td>
      <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.exwJapanDate | date : 'yy-MM-dd' }}</td>
      <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.arrivingVieDate | date : 'yy-MM-dd' }}</td>
      <td style="text-align:center">{{ spoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name }}</td>
      <td style="text-align:center">{{ transportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }}</td>
      <td style="text-align:right">{{ doc.unitQuantity | ngxRound : 3 }}</td>
      <td style="text-align:right;padding-right:10pt">{{ doc.quantity }}</td>
    </tr>
    <tr style="color:gray">
      <td style="text-align:right" colspan="7">OBIC:</td><td style="text-align:right">{{obicUnitQuantity | ngxRound : 3}}</td><td style="text-align:right;padding-right:10pt">{{obicQuantity}}</td>
    </tr>
    <tr style="color:gray">
      <td style="text-align:right" colspan="7">(PF)SPOs:</td><td style="text-align:right">{{spoUnitQuantity | ngxRound : 3}}</td><td style="text-align:right;padding-right:10pt">{{spoQuantity}}</td>
    </tr>
    <tr [style]="'color:gray;' + (obicQuantity-spoQuantity < 0 ? 'border:2px solid red' : 'font-style:italic' )">
      <td><button *ngIf="!print" class="nrk-button ml-2" (click)="copyObicSummaryToClipboard()">copy to clipboard</button></td>
      <td style="text-align:right" colspan="6">diff:</td><td style="text-align:right">{{obicUnitQuantity-spoUnitQuantity | ngxRound : 3}}</td><td style="text-align:right;padding-right:10pt">{{obicQuantity-spoQuantity}}</td>
    </tr>
  </table>

  <!-- <ng-container *ngIf="isScreen(section)">
    <ngx-line-item-pfspo-selector class="nrk-smaller-font" [mode]="2" [pfspoData]="pfspoSelectorData" [disabled]="isDisabled(section)" [compilation]="compilation"></ngx-line-item-pfspo-selector>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-line-item-pfspo-selector [mode]="3" [print]="true" [pfspoData]="pfspoSelectorData"></ngx-line-item-pfspo-selector>
  </ng-container> -->

</ng-template>

<!-- .................................................................. ocSummary ..................................................................... -->

<ng-template [dynamic]="'ocSummary'" let-section>

  <label>OC summary</label>
  <table class="nrk-table w-100">
    <tr>
      <th style="text-align:left;padding-left:10pt">OC #</th>
      <th style="text-align:left">PO #</th>
      <th style="text-align:center">Pos</th>
      <th style="text-align:right">Q/pc.</th>
      <th style="text-align:center">CRDD</th>
    </tr>
    <!-- <tr *ngFor="let doc of getAssociatedSpos(); index as idx"> -->
    <!-- <ng-container *ngFor="let li of compilation.lineItems; index as idx">
      <tr *ngFor="let doc of li.relatedOCs;">
        <td style="text-align:left;padding-left:10pt">{{ doc.doc | documentNumber : null : null : false }}</td>
        <td style="text-align:left">{{doc.doc.customerDocumentNumber}}</td>
        <td style="text-align:center">{{idx+1}}</td>
        <td style="text-align:right; white-space:nowrap">{{doc.quantity}}</td>
        <td style="text-align:center; white-space:nowrap">{{doc.doc.customerRequestedDeliveryDate | date : 'yy-MM-dd' }}</td>
      </tr>
    </ng-container> -->
    <tr *ngFor="let doc of linkedOCs">
        <td style="text-align:left;padding-left:10pt">{{ doc | documentNumber : null : null : false }}</td>
        <td style="text-align:left">{{doc.customerDocumentNumber}}</td>
        <td style="text-align:center">{{doc.pos}}</td>
        <td style="text-align:right; white-space:nowrap">{{doc.quantity}}</td>
        <td style="text-align:center; white-space:nowrap">{{doc.customerRequestedDeliveryDate | date : 'yy-MM-dd' }}</td>
    </tr>
    <tr [style]="'color:gray;' + (obicQuantity-spoQuantity < 0 ? 'border:2px solid red' : 'font-style:italic' )">
      <td><button *ngIf="!print" class="nrk-button ml-2" (click)="copyOcSummaryToClipboard()">copy to clipboard</button></td>
    </tr>
  </table>

</ng-template>

<!-- .................................................................. associatedPfspoList ..................................................................... -->

<ng-template [dynamic]="'associatedPfspoList'" let-section>

  <table class="nrk-table w-100">
    <tr>
      <th>OC #</th>
      <!-- OC Pos	(PF)SPO #	SPO Pos	Prod code	Product	Dimensions	Quantity	Unit	EXW date	VIE arrival date	PFSPO status	Transport status	Planned quantity -->
      <th>OC Pos</th>
      <th>(PF)SPO #</th>
      <th>SPO Pos</th>
      <th>Prod code</th>
      <!-- <th>Product	Dimensions</th> -->
      <th>Quantity</th>
      <th>Unit</th>
      <th>EXW date</th>
      <th>VIE arrival date</th>
      <th>PFSPO status</th>
      <th>Transport status</th>
      <th>Assigned quantity</th>
    </tr>
    <tr *ngFor="let doc of getAssociatedSpos()">
      <td>{{doc.oc | documentNumber : null : false : true}}</td>
      <td style="text-align:center">{{doc.parentPos+1}}</td>
      <td>{{doc | documentNumber : null : false : true}}</td>
      <td style="text-align:center">{{doc.pos}}</td>
      <td>{{doc.docLineItem?.finishedProduct?.calcName}}</td>
      <!-- <td>{{doc.docLineItem?.finishedProduct?.content?.energy?.width+'x'}}</td> -->
      <td>{{doc.docLineItem?.displayUnitQuantity}}</td>
      <td>{{unitData.get(doc.docLineItem?.displayUnit)?.short}}</td>
      <td style="white-space:nowrap">{{doc.doc?.exwJapanDate | date : 'yy-MM-dd'}}</td>
      <td style="white-space:nowrap">{{doc.doc?.arrivingVieDate | date : 'yy-MM-dd'}}</td>
      <td>{{spoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name}}</td>
      <td>{{transportStatusData.get(doc.doc?.transportRun.transportStatus)?.name}}</td>
      <td>{{doc.quantity}}</td>
    </tr>
  </table>

  <!-- <ng-container *ngIf="isScreen(section)">
    <ngx-line-item-pfspo-selector class="nrk-smaller-font" [mode]="2" [pfspoData]="pfspoSelectorData" [disabled]="isDisabled(section)" [compilation]="compilation"></ngx-line-item-pfspo-selector>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-line-item-pfspo-selector [mode]="3" [print]="true" [pfspoData]="pfspoSelectorData"></ngx-line-item-pfspo-selector>
  </ng-container> -->

</ng-template>

<!-- .................................................................. associatedOCList ..................................................................... -->

<ng-template [dynamic]="'associatedOCList'" let-section>

  <table class="nrk-table w-100">
    <tr>
      <th>OC#</th>
      <th>OC Pos</th>
      <th>Q</th>
      <th>Unit</th>
      <th>Dispatch date</th>
      <th>ETA customer</th>
      <th>CRDD</th>
      <th>CADD</th>
      <th>assigned Q</th>
    </tr>
    <tr *ngFor="let oc of tree.getRelatedOCs(); let lidx = index">
      <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
        [queryParams]="{code: oc.doc.code}" >{{oc.doc | documentNumber}}</a></td>
      <td style="text-align:center">{{oc.pos}}</td>
      <td>{{oc.doc.lineItems[lidx]?.displayUnitQuantity}}</td>
      <td>{{unitData.get(oc.doc.lineItems[lidx]?.displayUnit)?.short}}</td>
      <td style="white-space:nowrap">{{oc.doc.vieDispatchDate | date : 'yy-MM-dd'}}</td>
      <td style="white-space:nowrap">{{oc.doc.etaCustomerDate | date : 'yy-MM-dd'}}</td>
      <td style="white-space:nowrap">{{oc.doc.customerRequestedDeliveryDate | date : 'yy-MM-dd'}}</td>
      <td style="white-space:nowrap">{{oc.doc.customerAcceptedDeliveryDate | date : 'yy-MM-dd'}}</td>
      <td>{{oc.quantity}}</td>
    </tr>
  </table>

</ng-template>

<!-- .................................................................. documents ..................................................................... -->

<ng-template [dynamic]="'documents'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ng-container *ngFor="let type of object.keys(compilation.documents || []);">
      <ng-container *ngIf="compilation.documents[type]?.length && (type != ''+compilation.type || isDisabled(section)) ">
        <div class="files-sub-header"><i>{{getDocType(type)?.name || 'Project'}} related documents</i></div>
        <table class="files-table">
          <tr *ngFor="let file of compilation.documents[type]; index as idx">
            <td>
              <div>
                <ng-container *ngIf="isDisabled(section)">{{ file.checked ? '☑' : '☐' }}</ng-container>
                <ng-container *ngIf="!isDisabled(section) && !print"><input type="checkbox" [(ngModel)]="file.checked"></ng-container>
                {{getDocType(type)?.code || 'PRD'}}{{idx+1}}
              </div>
            </td><td class="pseudo-link" (click)="api.downloadFile(file)">
              {{file.name}}
            </td><td>
              {{file.comment || ''}}
            </td><td *ngIf="!isDisabled(section)" style="width: 30px">
              <button class="nrk-doc-button" (click)="compilation.documents[type] = removeFile(compilation.documents[type], file)">X</button>
            </td>
          </tr>
        </table>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!isDisabled(section)">
      <div class="files-sub-header"><i>{{getDocType(compilation.type)?.name}} related documents</i></div>
      <div class="file-upload">
        <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf" [descriptionOptions]="data.getFileDescriptions('relatedDocuments')"
          [(files)]="$any(compilation).documents[compilation.type]" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="false" [disabled]="isDisabled(section)">
        </ngx-form-upload>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ng-container *ngFor="let type of object.keys(compilation.documents || []);">
      <ng-container *ngIf="checkedFiles(compilation.documents[type])?.length">
        <!-- <ng-container *ngTemplateOutlet="subComponent; context: { $implicit: getSection('associatedPfspoList') }"></ng-container> -->

        <div class="files-sub-header"><i>{{getDocType(type)?.name || 'Project'}} related documents</i></div>
        <table class="files-table">
          <tr *ngFor="let file of checkedFiles(compilation.documents[type]); index as idx">
            <td>{{getDocType(type)?.code || 'PRD'}}{{idx+1}}</td><td>{{file.name}}</td><td>{{file.comment || ''}}</td>
          </tr>
        </table>
      </ng-container>
    </ng-container>
  </ng-container>

</ng-template>

<!-- .................................................................. test certificates ..................................................................... -->

<ng-template [dynamic]="'testCertificates'" let-section>

  <ng-container>
    <table class="files-table">
      <tr *ngFor="let file of compilation.testCertificates; index as idx">
        <td>
          <div>
            <ng-container *ngIf="isDisabled(section)">{{ file.checked ? '☑' : '☐' }}</ng-container>
            <ng-container *ngIf="!isDisabled(section) && !print"><input type="checkbox" [(ngModel)]="file.checked"></ng-container>
            TC{{idx+1}}
          </div>
        </td><td class="pseudo-link" (click)="api.downloadFile(file)">
          {{file.name}}
        </td><td>
          {{file.comment || ''}}
        </td>
      </tr>
    </table>
  </ng-container>

  <ng-container *ngIf="isScreen(section) && !isDisabled(section)">
    <div class="file-upload">
      <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
        [(files)]="compilation.testCertificates" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="false" [disabled]="isDisabled(section)">
      </ngx-form-upload>
    </div>
  </ng-container>

</ng-template>

<!-- .............................................................. test certificates from pfspos ..................................................................... -->

<ng-template [dynamic]="'tcFromPfspo'" let-section>

  <ng-container>
    <table class="spo-files-table">
      <ng-container *ngFor="let spo of tree.linkedPfspos">
        <tr *ngFor="let file of spo?.testCertificates; index as idx">
          <td>{{spo.code}}</td>
          <td>
            <div>
              <ng-container *ngIf="isDisabled(section)">{{ file.checked ? '☑' : '☐' }}</ng-container>
              <ng-container *ngIf="!isDisabled(section) && !print"><input type="checkbox" [(ngModel)]="file.checked"></ng-container>
              TC{{idx+1}}
            </div>
          </td><td class="pseudo-link" (click)="api.downloadFile(file)">
              {{file.name}}
          </td><td>
            {{file.comment || ''}}
          </td>
        </tr>
      </ng-container>
    </table>
  </ng-container>

  <!-- <ng-container *ngIf="isScreen(section) && !isDisabled(section)">
    <div class="file-upload">
      <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
        [(files)]="compilation.testCertificates" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="false" [disabled]="isDisabled(section)">
      </ngx-form-upload>
    </div>
  </ng-container> -->

</ng-template>

<!-- .................................................................. technicalDatasheetPdf ..................................................................... -->

<ng-template [dynamic]="'technicalDatasheetPdf'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <table class="finished-product-pdf">
      <tr><th>Finished product</th><th>TDS</th><th>No</th><th>Yes</th></tr>
      <ng-container *ngFor="let item of compilation.lineItems">
        <tr *ngFor="let tds of getTDS(item); index as idx">
          <td>{{item.finishedProduct?.calcName}}</td>
          <td style="text-align:left">{{tds.name}}</td>
          <td><input type="radio" [name]="item.finishedProduct._id+'-tds-'+idx" [value]="0" [(ngModel)]="item.technicalDatasheets[idx]" (ngModelChange)="item.technicalDatasheets[idx]=0" /></td>
          <td><input type="radio" [name]="item.finishedProduct._id+'-tds-'+idx" [value]="1" [(ngModel)]="item.technicalDatasheets[idx]" (ngModelChange)="item.technicalDatasheets[idx]=1"/></td>
        </tr>
      </ng-container>
    </table>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ng-container *ngFor="let item of compilation.lineItems; index as lidx">
      <div class="files-sub-header"><i>{{item.finishedProduct?.calcName}}</i></div>
      <table class="files-table">
        <ng-container *ngFor="let tds of getTDS(item); index as idx">
          <tr *ngIf="item.technicalDatasheets[idx] > 0">
            <td>TDS {{lidx+1}}.{{idx+1}}</td><td>{{tds.name}}</td><td>{{tds.comment || ''}}</td>
          </tr>
        </ng-container>
      </table>
    </ng-container>
  </ng-container>

</ng-template>

<!-- .................................................................. finishedProductPdf ..................................................................... -->

<ng-template [dynamic]="'finishedProductPdf'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <table class="finished-product-pdf">
      <tr><th>Finished product</th><th>None</th><!--<th>Single-PDF</th><th>Merged-PDF</th><th>Attachments only</th>--><th>ZIP</th></tr>
      <tr *ngFor="let item of compilation.lineItems">
        <td>{{item.finishedProduct?.calcName}}</td>
        <td><input type="radio" [name]="item.finishedProduct?._id" [(ngModel)]="item.finishedProductPdf" [value]="0" (ngModelChange)="item.finishedProductPdf=0" /></td>
        <!-- <td><input type="radio" [name]="item.finishedProduct._id" [(ngModel)]="item.finishedProductPdf" [value]="1" (ngModelChange)="item.finishedProductPdf=1"/></td>
        <td><input type="radio" [name]="item.finishedProduct._id" [(ngModel)]="item.finishedProductPdf" [value]="2" (ngModelChange)="item.finishedProductPdf=2" /></td>
        <td><input type="radio" [name]="item.finishedProduct._id" [(ngModel)]="item.finishedProductPdf" [value]="3" (ngModelChange)="item.finishedProductPdf=3" /></td> -->
        <td><input type="radio" [name]="item.finishedProduct?._id" [(ngModel)]="item.finishedProductPdf" [value]="4" (ngModelChange)="item.finishedProductPdf=4" /></td>
      </tr>
    </table>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ng-container *ngFor="let item of compilation.lineItems; index as lidx">
      <div class="files-sub-header"><i>{{item.finishedProduct?.calcName}}</i></div>
      <table class="files-table">
        <ng-container *ngFor="let file of item.finishedProduct.files; index as idx">
          <tr *ngIf="item.finishedProductPdf > 1">
            <td>FPS {{lidx+1}}.{{idx+1}}</td><td>{{file.name}}</td><td>{{file.comment || ''}}</td>
          </tr>
        </ng-container>
      </table>
    </ng-container>
  </ng-container>

</ng-template>

<!-- .................................................................. changelogFiles ..................................................................... -->

<ng-template [dynamic]="'changelogFiles'" let-section>

  <!-- <ng-container *ngIf="isScreen(section)">
    <ngx-changelog [abstractItem]="compilation" [print]="false" [disabled]="isDisabled(section)" (uploadCompleted)="changelogUploadCompleted()"></ngx-changelog>
  </ng-container> -->

  <ng-container>
    <table class="files-table">
      <ng-container *ngFor="let item of $any(compilation).changelog; index as lidx">
        <ng-container *ngFor="let file of item.files; index as idx;">
          <tr *ngIf="file.checked">
            <td>CLD {{getCLDNum(lidx,idx)}}</td><td class="pseudo-link" (click)="api.downloadFile(file)">{{file.name}}</td><td>{{file.comment || ''}}</td>
            <td *ngIf="!isDisabled(section) && !isPrint(section)" style="width: 30px">
              <button class="nrk-doc-button" (click)="item.files = removeFile(item.files, file)">X</button>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </ng-container>

</ng-template>

<!-- .................................................................. packingImages ..................................................................... -->

<ng-template [dynamic]="'packingImages'" let-section>


  <ng-container *ngIf="isScreen(section)">
    <ngx-form-upload
      [files]="compilation.packingImages"
      url="/api/v1/upload"
      title="Packing Images Upload"
      accept="image/jpeg"
      [preview]="true"
      [fullwidth]="true"
      [disabled]="isDisabled(section)"
    ></ngx-form-upload>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <table class="files-table">
      <ng-container *ngFor="let file of compilation.packingImages; index as lidx">
        <tr *ngIf="file.checked">
          <td class="pseudo-link" style="text-align: left" (click)="api.downloadFile(file)">{{file.name}}</td><td>{{file.comment || ''}}</td>
          <td *ngIf="!isDisabled(section) && !isPrint(section)" style="width: 30px">
            <button class="nrk-doc-button" (click)="compilation.packingImages = removeFile(compilation.packingImages, file)">X</button>
          </td>
        </tr>
      </ng-container>
    </table>
  </ng-container>

</ng-template>

<!-- .................................................................. dnBoxes ..................................................................... -->

<ng-template [dynamic]="'dnBoxes'" let-section>

  <div *ngFor="let _ of [].constructor(dnBoxesPageCount); let pageIndex = index" class="landscape" style="page-break-after: always;">
    <table class="nrk-table w-100 boxes-table" style="font-size: 9pt">
      <tr>
        <ng-container *ngFor="let col of boxConfig">
          <th [style.text-align]="col.align" [style.width]="col.width">{{col.header}}</th>
        </ng-container>
      </tr>
      <tr *ngFor="let row of dnBoxesPageRows(pageIndex)">
        <ng-container *ngFor="let col of boxConfig">
          <td [style.text-align]="col.align" [style.width]="col.width">{{row[col.name]}}</td>
        </ng-container>
      </tr>
    </table>
  </div>

</ng-template>

<!-- .................................................................. changelog ..................................................................... -->

<ng-template [dynamic]="'changelog'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-changelog [abstractItem]="compilation" [print]="false" [disabled]="isDisabled(section)" (uploadCompleted)="changelogUploadCompleted()"></ngx-changelog>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-changelog [abstractItem]="compilation" [print]="true" [disabled]="isDisabled(section)" (uploadCompleted)="changelogUploadCompleted()"></ngx-changelog>
  </ng-container>

</ng-template>

<!-- .................................................................. changelog lite ..................................................................... -->

<ng-template [dynamic]="'changelogLite'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-changelog [abstractItem]="compilation" [print]="false" [disabled]="isDisabled(section)" [compilation]="compilation" [lite]="true"></ngx-changelog>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <!-- <div id="changelogLite"> -->
      <ngx-changelog [abstractItem]="compilation" [print]="true" [disabled]="isDisabled(section)" [compilation]="compilation" [lite]="true"></ngx-changelog>
    <!-- </div> -->
  </ng-container>

</ng-template>

<!-- .................................................................. relatedDocuments ..................................................................... -->

<ng-template [dynamic]="'relatedDocuments'" let-section>

  <ng-container *ngIf="relatedDocuments && relatedDocuments.length > 1">
    <table>
      <tr *ngFor="let data of getRelatedDocumentsData(relatedDocuments)">
      <!-- <tr *ngFor="let data of relatedDocumentsData"> -->
        <td style="width:13em;white-space:nowrap">{{data.doc}}</td>
        <td style="width:8em; padding-left:1rem;white-space:nowrap">{{data.date}}</td>
        <td><span *ngIf="data.customerDoc">PO: {{data.customerDoc}}</span></td>
        <td><span *ngIf="data.customerDate">Date: {{data.customerDate | date : 'yy-MM-dd'}}</span></td>
      </tr>
    </table>
  </ng-container>
  <ng-container *ngIf="!relatedDocuments || relatedDocuments.length < 2">
    <div>No related documents</div>
  </ng-container>

</ng-template>

<!-- .................................................................. accountManager ..................................................................... -->

<ng-template [dynamic]="'accountManager'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-form-text [multiline]="1" [value]="compilation.accountManager" [disabled]="true"></ngx-form-text>
  </ng-container>

</ng-template>

<!-- .................................................................. invoiceRemark ..................................................................... -->

<ng-template [dynamic]="'invoiceRemark'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-form-text [multiline]="1" [value]="section.value" [disabled]="true"></ngx-form-text>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <div>{{section.value}}</div>
  </ng-container>

</ng-template>

<!-- .................................................................. issuedBy ..................................................................... -->

<ng-template [dynamic]="'issuedBy'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-form-text [multiline]="1" [value]="auth.user.name" [disabled]="true"></ngx-form-text>
  </ng-container>

</ng-template>

<!-- .................................................................. bankAddress ..................................................................... -->

<ng-template [dynamic]="'bankAddress'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-form-text [multiline]="3" [value]="compilation.documentFooter?.bank" [disabled]="true"></ngx-form-text>
  </ng-container>

</ng-template>

<!-- .................................................................. barcodes ..................................................................... -->

<ng-template [dynamic]="'barcodes'" let-section>

  <ng-container *ngIf="isScreen(section)">
    <ngx-barcodes [compilation]="compilation" [disabled]="isDisabled(section)" (dataChange)="qrcode.setQrData($event)"></ngx-barcodes>
  </ng-container>

  <ng-container *ngIf="isPrint(section)">
    <ngx-barcodes [compilation]="compilation" [print]="true" [disabled]="isDisabled(section)"></ngx-barcodes>
  </ng-container>

</ng-template>

<!-- .................................................................. qr code ..................................................................... -->

<ng-template [dynamic]="'qrcode'" let-section>

  <div>
    <ngx-barcodes #qrcode [compilation]="compilation" type="qrcode" [disabled]="isDisabled(section)"></ngx-barcodes>
  </div>

</ng-template>

<!-- .................................................................. cover sheet ..................................................................... -->

<ng-template [dynamic]="'coverSheet'" let-section>

  <ngx-cover-sheet [print]="isPrint(section)" [compilation]="compilation"></ngx-cover-sheet>

</ng-template>

<!-- ............................................................. send to / general info  ..................................................................... -->

<ng-template [dynamic]="'sendToSection'" let-section>
  <div *ngIf="compilation && documentComponent">
    <!-- <b>{{data.getBusinessName(compilation.recipient)}}</b> -->
    <div style="display:flex;padding:0.5rem 0;" *ngIf="
      compilation.invoiceSendTo?.length || documentComponent.invoiceSendTo?.length
      || documentComponent.deliveryNoteSendTo?.length
      || documentComponent.testCertificateSendTo?.length
      || documentComponent.invoiceReminderSendTo?.length
    ">
      <div *ngIf="compilation.invoiceSendTo?.length || documentComponent.invoiceSendTo?.length" class="send-to-section">
        <div><b>Send IN to:</b></div>
        <div class="send-to-info">{{compilation.invoiceSendTo || documentComponent.invoiceSendTo}}</div>
      </div>
      <div *ngIf="documentComponent.deliveryNoteSendTo?.length" class="send-to-section">
        <div><b>Send DN to:</b></div>
        <div class="send-to-info">{{documentComponent.deliveryNoteSendTo}}</div>
      </div>
      <div *ngIf="documentComponent.testCertificateSendTo?.length" class="send-to-section">
        <div><b>Send TC to:</b></div>
        <div class="send-to-info">{{documentComponent.testCertificateSendTo}}</div>
      </div>
      <div *ngIf="documentComponent.invoiceReminderSendTo?.length" class="send-to-section">
        <div><b>Send Invoice Reminder to:</b></div>
        <div class="send-to-info">{{documentComponent.invoiceReminderSendTo}}</div>
      </div>                
    </div>
    <div style="padding:0.5rem 0" *ngIf="documentComponent.businessGeneralInfo">
      <div><b>General Information:</b></div>
      <div class="send-to-info">{{documentComponent.businessGeneralInfo}}</div>
    </div>
  </div>
</ng-template>

<!-- .................................................................. issuerFooter ..................................................................... -->

<ng-template [dynamic]="'issuerFooter'" let-section>

  <ng-container *ngIf="!single">
    <table class="issuer-footer">
      <tr>
        <td>BU: <span>{{getBusinessUnits()}}</span></td>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td>Issued by: <span>{{getIssuedBy()}}</span></td>
        <td><span>{{getIssuer()}}</span></td>
      </tr>
    </table>
  </ng-container>

</ng-template>








